import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDrop } from "react-dnd";
import { CanvasContext } from "../../../contexts/CanvasContext";
import ButtonComponent from "./ButtonComponent";
import ImageComponent from "./ImageComponent";
import HeaderComponent from "./HeaderComponent";
import ParagraphComponent from "./ParagraphComponent";
import IconComponent from "./IconComponent";
import LinkComponent from "./LinkComponent";
import CheckboxComponent from "./CheckboxComponent";
import RadioComponent from "./RadioComponent";
import ListComponent from "./ListComponent";
import TableComponent from "./TableComponent";
import VideoComponent from "./VideoComponent";
import TextInputComponent from "./TextComponent";
import RangeComponent from "./RangeComponent";
import PasswordInputComponent from "./PasswordInputComponent";
import EmailInputComponent from "./EmailInputComponent";
import NumberInputComponent from "./NumberInputComponent";
import DateInputComponent from "./DateInputComponent";
import ColorInputComponent from "./ColorInputComponent";
import FileInputComponent from "./FileInputComponent";
import AudioComponent from "./AudioComponent";
import DropDownComponent from "./DropDownComponent";
import MapComponent from "./MapComponent";
import Division from "./Division";
import Span from "./Span";
import FormComponent from "./FormComponent";
import MainComponent from "./MainComponent";
import ArticleComponent from "./ArticleComponent";
import AsideComponent from "./AsideComponent";
import HRTag from "./HRTag";
import BRTag from "./BRTag";
import OutputComponent from "./OutputComponent";
import IframeComponent from "./IframeComponent";
import Nav from "./Nav";

const HeaderTag = ({ headertag }) => {
  const headertagRef = useRef(null);

  const { addElement, hoveredDivision, files, addDivision, addCanvasDrop } =
    useContext(CanvasContext);
  const isHovered = headertag.id === hoveredDivision;
  const [isHeadertagHovered, setIsHeadertagHovered] = useState(false);
  const [isHeadertagFocused, setIsHeadertagFocused] = useState(false);
  const [isHeadertagActive, setIsHeadertagActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = headertag;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = headertag;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = headertag;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = headertag;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const generateKeyframes = () => {
    if (!headertag.keyframes || headertag.keyframes.length === 0) return null;

    return headertag.keyframes.map((kf) => {
      const properties = {};
      let transform = "";

      Object.entries(kf.properties).forEach(([key, value]) => {
        // Remove 'KEY' prefix if present
        let processedKey = key.startsWith("KEY") ? key.slice(3) : key;

        // Handle transform properties
        if (
          processedKey === "scale" ||
          processedKey === "translateX" ||
          processedKey === "translateY" ||
          processedKey === "rotate" ||
          processedKey === "skewX" ||
          processedKey === "skewY"
        ) {
          if (value) {
            switch (processedKey) {
              case "scale":
                transform += `scale(${value}) `;
                break;
              case "translateX":
                transform += `translateX(${value}) `;
                break;
              case "translateY":
                transform += `translateY(${value}) `;
                break;
              case "rotate":
                transform += `rotate(${value}) `;
                break;
              case "skewX":
                transform += `skewX(${value}) `;
                break;
              case "skewY":
                transform += `skewY(${value}) `;
                break;
              default:
                break;
            }
          }
        } else {
          // Convert camelCase to kebab-case for other CSS properties
          properties[processedKey] = value;
        }
      });

      // Add transform property if it was built
      if (transform) {
        properties["transform"] = transform.trim();
      }

      return {
        offset: kf.position / 100,
        ...properties,
      };
    });
  };

  useEffect(() => {
    if (
      headertagRef.current &&
      headertag.keyframes &&
      headertag.keyframes.length > 0
    ) {
      const keyframes = generateKeyframes();
      const animation = headertagRef.current.animate(keyframes, {
        duration: parseFloat(headertag.animationDuration) * 1000 || 1000,
        delay: parseFloat(headertag.animationDelay) * 1000 || 0,
        iterations:
          headertag.animationIterationCount === "infinite"
            ? Infinity
            : parseFloat(headertag.animationIterationCount) || 1,
        direction: headertag.animationDirection || "normal",
        fill: headertag.animationFillMode || "none",
        easing: headertag.animationTimingFunction || "linear",
      });

      return () => animation.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    headertag.keyframes,
    headertag.animationDuration,
    headertag.animationDelay,
    headertag.animationIterationCount,
    headertag.animationDirection,
    headertag.animationFillMode,
    headertag.animationTimingFunction,
  ]);

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        headertag.backgroundImage &&
        headertag.backgroundImage.startsWith("./")
      ) {
        const imageName = headertag.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(headertag.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [headertag.backgroundImage, files]);

  const focusedStyles =
    isHeadertagFocused && headertag.pseudoClass === "focus"
      ? {
          width: headertag.focusedwidth || headertag.width || "100%",
          height: headertag.focusedheight || headertag.height || "auto",

          padding: headertag.focusedpadding || headertag.padding || "8px",
          paddingTop:
            headertag.focusedpaddingTop || headertag.focusedpadding || "8px",
          paddingRight:
            headertag.focusedpaddingRight || headertag.focusedpadding || "8px",
          paddingBottom:
            headertag.focusedpaddingBottom || headertag.focusedpadding || "8px",
          paddingLeft:
            headertag.focusedpaddingLeft || headertag.focusedpadding || "8px",
          margin: headertag.focusedmargin || headertag.margin || "0px",
          marginTop:
            headertag.focusedmarginTop || headertag.focusedmargin || "0px",
          marginRight:
            headertag.focusedmarginRight || headertag.focusedmargin || "0px",
          marginBottom:
            headertag.focusedmarginBottom || headertag.focusedmargin || "0px",
          marginLeft:
            headertag.focusedmarginLeft || headertag.focusedmargin || "0px",

          borderTop:
            headertag.focusedborderTop ||
            headertag.focusedborder ||
            headertag.border ||
            "1px solid black",
          borderRight:
            headertag.focusedborderRight ||
            headertag.focusedborder ||
            headertag.border ||
            "1px solid black",
          borderBottom:
            headertag.focusedborderBottom ||
            headertag.focusedborder ||
            headertag.border ||
            "1px solid black",
          borderLeft:
            headertag.focusedborderLeft ||
            headertag.focusedborder ||
            headertag.border ||
            "1px solid black",
          borderSapcing:
            headertag.focusedborderSpacing || headertag.borderSpacing || "0px",
          borderCollapse:
            headertag.focusedborderCollapse ||
            headertag.borderCollapse ||
            "0px",
          borderRadius:
            headertag.focusedborderRadius || headertag.borderRadius || "0",
          outline: headertag.focusedoutline || headertag.outline || "none",

          position:
            headertag.focusedposition || headertag.position || "relative",
          top: headertag.focusedtop || headertag.top || "auto",
          right: headertag.focusedright || headertag.right || "auto",
          bottom: headertag.focusedbottom || headertag.bottom || "auto",
          left: headertag.focusedleft || headertag.left || "auto",
          zIndex: headertag.focusedzIndex || headertag.zIndex || "auto",
          boxShadow:
            headertag.focusedboxShadow || headertag.boxShadow || "none",
          opacity: headertag.focusedOpacity || headertag.opacity || 1,
          display: headertag.focuseddisplay || headertag.display || "block",
          flexDirection:
            headertag.focusedflexDirection ||
            headertag.flexDirection ||
            "column",
          flexWrap: headertag.focusedflexWrap || "nowrap",
          order: headertag.focusedorder || "0",
          flexGrow: headertag.focusedflexGrow || "0",
          flexShrink: headertag.focusedflexShrink || "1",
          flexBasis: headertag.focusedflexBasis || "auto",

          gridTemplateColumns: headertag.focusedgridTemplateColumns || "none",
          gridTemplateRows: headertag.focusedgridTemplateRows || "none",
          gridArea: headertag.focusedgridArea || "auto",
          gridAutoFlow: headertag.focusedgridAutoFlow || "row",
          gridAutoColumns: headertag.focusedgridAutoColumns || "auto",
          gridAutoRows: headertag.focusedgridAutoRows || "auto",
          columnGap: headertag.focusedcolumnGap || "0",
          rowGap: headertag.focusedrowGap || "0",

          justifyContent: headertag.focusedjustifyContent || "flex-start",
          alignItems: headertag.focusedalignItems || "stretch",
          alignContent: headertag.focusedalignContent || "stretch",
          alignSelf: headertag.focusedalignSelf || "auto",
          // placeContent: headertag.focusedplaceContent || "normal",
          // placeItems: headertag.focusedplaceItems || "normal",
          justifyItems: headertag.focusedjustifyItems || "stretch",
          justifySelf: headertag.focusedjustifySelf || "auto",

          gap: headertag.focusedgap || "0",
          visibility: headertag.focusedvisibility || "visible",

          color: headertag.focusedcolor || headertag.color || "#000000",
          backgroundColor:
            headertag.focusedbackgroundColor ||
            headertag.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (headertag.focusedbackgroundImage) {
              if (headertag.focusedbackgroundImage.startsWith("./")) {
                const imageName = headertag.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${headertag.focusedbackgroundImage})`;
            }
            if (headertag.backgroundImage) {
              if (headertag.backgroundImage.startsWith("./")) {
                const imageName = headertag.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${headertag.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            headertag.focusedbackgroundPosition ||
            headertag.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            headertag.focusedbackgroundSize ||
            headertag.backgroundSize ||
            "auto",
          backgroundRepeat:
            headertag.focusedbackgroundRepeat ||
            headertag.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            headertag.focusedbackgroundAttachment ||
            headertag.backgroundAttachment ||
            "scroll",

          fontFamily:
            headertag.focusedfontFamily || headertag.fontFamily || "inherit",
          fontSize:
            headertag.focusedfontSize || headertag.fontSize || "inherit",
          fontWeight:
            headertag.focusedfontWeight || headertag.fontWeight || "normal",
          fontStyle:
            headertag.focusedfontStyle || headertag.fontStyle || "normal",
          fontVariant:
            headertag.focusedfontVariant || headertag.fontVariant || "normal",
          lineHeight:
            headertag.focusedlineHeight || headertag.lineHeight || "normal",
          textShadow:
            headertag.focusedtextShadow || headertag.textShadow || "none",
          textAlign:
            headertag.focusedtextAlign || headertag.textAlign || "left",
          verticalAlign:
            headertag.focusedverticalAlign ||
            headertag.verticalAlign ||
            "baseline",
          textDecoration:
            headertag.focusedtextDecoration ||
            headertag.textDecoration ||
            "none",
          textTransform:
            headertag.focusedtextTransform || headertag.textTransform || "none",
          letterSpacing:
            headertag.focusedletterSpacing ||
            headertag.letterSpacing ||
            "normal",
          wordSpacing:
            headertag.focusedwordSpacing || headertag.wordSpacing || "normal",
          textIndent:
            headertag.focusedtextIndent || headertag.textIndent || "0",
          whiteSpace:
            headertag.focusedwhiteSpace || headertag.whiteSpace || "normal",
          textOverflow:
            headertag.focusedtextOverflow || headertag.textOverflow || "clip",
          direction: headertag.focuseddirection || headertag.direction || "ltr",
          unicodeBidi:
            headertag.focusedunicodeBidi || headertag.unicodeBidi || "normal",
          writingMode:
            headertag.focusedwritingMode ||
            headertag.writingMode ||
            "horizontal-tb",

          cursor: headertag.focusedcursor || headertag.cursor || "default",
          filter: headertag.focusedfilter || headertag.filter || "none",
          backdropFilter:
            headertag.focusedbackdropFilter ||
            headertag.backdropFilter ||
            "none",
          mixBlendMode:
            headertag.focusedmixBlendMode || headertag.mixBlendMode || "normal",
          aspectRatio:
            headertag.focusedaspectRatio || headertag.aspectRatio || "auto",

          transform:
            headertag.focusedtransform || headertag.transform || "none",
          transition:
            headertag.focusedtransition || headertag.transition || "none",
        }
      : {};

  const hoverStyles =
    isHeadertagHovered && headertag.pseudoClass === "hover"
      ? {
          width: headertag.hoveredwidth || headertag.width || "100%",
          height: headertag.hoveredheight || headertag.height || "auto",

          padding: headertag.hoveredpadding || headertag.padding || "8px",
          paddingTop:
            headertag.hoveredpaddingTop || headertag.hoveredpadding || "8px",
          paddingRight:
            headertag.hoveredpaddingRight || headertag.hoveredpadding || "8px",
          paddingBottom:
            headertag.hoveredpaddingBottom || headertag.hoveredpadding || "8px",
          paddingLeft:
            headertag.hoveredpaddingLeft || headertag.hoveredpadding || "8px",
          margin: headertag.hoveredmargin || headertag.margin || "0px",
          marginTop:
            headertag.hoveredmarginTop || headertag.hoveredmargin || "0px",
          marginRight:
            headertag.hoveredmarginRight || headertag.hoveredmargin || "0px",
          marginBottom:
            headertag.hoveredmarginBottom || headertag.hoveredmargin || "0px",
          marginLeft:
            headertag.hoveredmarginLeft || headertag.hoveredmargin || "0px",

          borderTop:
            headertag.hoveredborderTop ||
            headertag.hoveredborder ||
            headertag.border ||
            "1px solid black",
          borderRight:
            headertag.hoveredborderRight ||
            headertag.hoveredborder ||
            headertag.border ||
            "1px solid black",
          borderBottom:
            headertag.hoveredborderBottom ||
            headertag.hoveredborder ||
            headertag.border ||
            "1px solid black",
          borderLeft:
            headertag.hoveredborderLeft ||
            headertag.hoveredborder ||
            headertag.border ||
            "1px solid black",
          borderSapcing:
            headertag.hoveredborderSpacing || headertag.borderSpacing || "0px",
          borderCollapse:
            headertag.hoveredborderCollapse ||
            headertag.borderCollapse ||
            "0px",
          borderRadius:
            headertag.hoveredborderRadius || headertag.borderRadius || "0",
          outline: headertag.hoveredoutline || headertag.outline || "none",

          position:
            headertag.hoveredposition || headertag.position || "relative",
          top: headertag.hoveredtop || headertag.top || "auto",
          right: headertag.hoveredright || headertag.right || "auto",
          bottom: headertag.hoveredbottom || headertag.bottom || "auto",
          left: headertag.hoveredleft || headertag.left || "auto",
          zIndex: headertag.hoveredzIndex || headertag.zIndex || "auto",
          boxShadow:
            headertag.hoveredboxShadow || headertag.boxShadow || "none",
          opacity: headertag.hoveredOpacity || headertag.opacity || 1,
          display: headertag.hovereddisplay || headertag.display || "block",
          flexDirection:
            headertag.hoveredflexDirection ||
            headertag.flexDirection ||
            "column",
          flexWrap: headertag.hoveredflexWrap || "nowrap",
          order: headertag.hoveredorder || "0",
          flexGrow: headertag.hoveredflexGrow || "0",
          flexShrink: headertag.hoveredflexShrink || "1",
          flexBasis: headertag.hoveredflexBasis || "auto",

          gridTemplateColumns: headertag.hoveredgridTemplateColumns || "none",
          gridTemplateRows: headertag.hoveredgridTemplateRows || "none",
          gridArea: headertag.hoveredgridArea || "auto",
          gridAutoFlow: headertag.hoveredgridAutoFlow || "row",
          gridAutoColumns: headertag.hoveredgridAutoColumns || "auto",
          gridAutoRows: headertag.hoveredgridAutoRows || "auto",
          columnGap: headertag.hoveredcolumnGap || "0",
          rowGap: headertag.hoveredrowGap || "0",

          justifyContent: headertag.hoveredjustifyContent || "flex-start",
          alignItems: headertag.hoveredalignItems || "stretch",
          alignContent: headertag.hoveredalignContent || "stretch",
          alignSelf: headertag.hoveredalignSelf || "auto",
          // placeContent: headertag.hoveredplaceContent || "normal",
          // placeItems: headertag.hoveredplaceItems || "normal",
          justifyItems: headertag.hoveredjustifyItems || "stretch",
          justifySelf: headertag.hoveredjustifySelf || "auto",

          gap: headertag.hoveredgap || "0",
          visibility: headertag.hoveredvisibility || "visible",

          color: headertag.hoveredcolor || headertag.color || "#000000",
          backgroundColor:
            headertag.hoveredbackgroundColor ||
            headertag.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (headertag.hoveredbackgroundImage) {
              if (headertag.hoveredbackgroundImage.startsWith("./")) {
                const imageName = headertag.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${headertag.hoveredbackgroundImage})`;
            }
            if (headertag.backgroundImage) {
              if (headertag.backgroundImage.startsWith("./")) {
                const imageName = headertag.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${headertag.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            headertag.hoveredbackgroundPosition ||
            headertag.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            headertag.hoveredbackgroundSize ||
            headertag.backgroundSize ||
            "auto",
          backgroundRepeat:
            headertag.hoveredbackgroundRepeat ||
            headertag.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            headertag.hoveredbackgroundAttachment ||
            headertag.backgroundAttachment ||
            "scroll",

          fontFamily:
            headertag.hoveredfontFamily || headertag.fontFamily || "inherit",
          fontSize:
            headertag.hoveredfontSize || headertag.fontSize || "inherit",
          fontWeight:
            headertag.hoveredfontWeight || headertag.fontWeight || "normal",
          fontStyle:
            headertag.hoveredfontStyle || headertag.fontStyle || "normal",
          fontVariant:
            headertag.hoveredfontVariant || headertag.fontVariant || "normal",
          lineHeight:
            headertag.hoveredlineHeight || headertag.lineHeight || "normal",
          textShadow:
            headertag.hoveredtextShadow || headertag.textShadow || "none",
          textAlign:
            headertag.hoveredtextAlign || headertag.textAlign || "left",
          verticalAlign:
            headertag.hoveredverticalAlign ||
            headertag.verticalAlign ||
            "baseline",
          textDecoration:
            headertag.hoveredtextDecoration ||
            headertag.textDecoration ||
            "none",
          textTransform:
            headertag.hoveredtextTransform || headertag.textTransform || "none",
          letterSpacing:
            headertag.hoveredletterSpacing ||
            headertag.letterSpacing ||
            "normal",
          wordSpacing:
            headertag.hoveredwordSpacing || headertag.wordSpacing || "normal",
          textIndent:
            headertag.hoveredtextIndent || headertag.textIndent || "0",
          whiteSpace:
            headertag.hoveredwhiteSpace || headertag.whiteSpace || "normal",
          textOverflow:
            headertag.hoveredtextOverflow || headertag.textOverflow || "clip",
          direction: headertag.hovereddirection || headertag.direction || "ltr",
          unicodeBidi:
            headertag.hoveredunicodeBidi || headertag.unicodeBidi || "normal",
          writingMode:
            headertag.hoveredwritingMode ||
            headertag.writingMode ||
            "horizontal-tb",

          cursor: headertag.hoveredcursor || headertag.cursor || "default",
          filter: headertag.hoveredfilter || headertag.filter || "none",
          backdropFilter:
            headertag.hoveredbackdropFilter ||
            headertag.backdropFilter ||
            "none",
          mixBlendMode:
            headertag.hoveredmixBlendMode || headertag.mixBlendMode || "normal",
          aspectRatio:
            headertag.hoveredaspectRatio || headertag.aspectRatio || "auto",

          transform:
            headertag.hoveredtransform || headertag.transform || "none",
          transition:
            headertag.hoveredtransition || headertag.transition || "none",
        }
      : {};

  const activeStyles =
    isHeadertagActive && headertag.pseudoClass === "active"
      ? {
          width: headertag.activatedwidth || headertag.width || "100%",
          height: headertag.hoveredheight || headertag.height || "auto",

          padding: headertag.activatedpadding || headertag.padding || "8px",
          paddingTop:
            headertag.activatedpaddingTop ||
            headertag.activatedpadding ||
            "8px",
          paddingRight:
            headertag.activatedpaddingRight ||
            headertag.activatedpadding ||
            "8px",
          paddingBottom:
            headertag.activatedpaddingBottom ||
            headertag.activatedpadding ||
            "8px",
          paddingLeft:
            headertag.activatedpaddingLeft ||
            headertag.activatedpadding ||
            "8px",
          margin: headertag.activatedmargin || headertag.margin || "0px",
          marginTop:
            headertag.activatedmarginTop || headertag.activatedmargin || "0px",
          marginRight:
            headertag.activatedmarginRight ||
            headertag.activatedmargin ||
            "0px",
          marginBottom:
            headertag.activatedmarginBottom ||
            headertag.activatedmargin ||
            "0px",
          marginLeft:
            headertag.activatedmarginLeft || headertag.activatedmargin || "0px",

          borderTop:
            headertag.activatedborderTop ||
            headertag.activatedborder ||
            headertag.border ||
            "1px solid black",
          borderRight:
            headertag.activatedborderRight ||
            headertag.activatedborder ||
            headertag.border ||
            "1px solid black",
          borderBottom:
            headertag.activatedborderBottom ||
            headertag.activatedborder ||
            headertag.border ||
            "1px solid black",
          borderLeft:
            headertag.activatedborderLeft ||
            headertag.activatedborder ||
            headertag.border ||
            "1px solid black",
          borderSapcing:
            headertag.activatedborderSpacing ||
            headertag.borderSpacing ||
            "0px",
          borderCollapse:
            headertag.activatedborderCollapse ||
            headertag.borderCollapse ||
            "0px",
          borderRadius:
            headertag.activatedborderRadius || headertag.borderRadius || "0",
          outline: headertag.activatedoutline || headertag.outline || "none",

          position:
            headertag.activatedposition || headertag.position || "relative",
          top: headertag.activatedtop || headertag.top || "auto",
          right: headertag.activatedright || headertag.right || "auto",
          bottom: headertag.activatedbottom || headertag.bottom || "auto",
          left: headertag.activatedleft || headertag.left || "auto",
          zIndex: headertag.activatedzIndex || headertag.zIndex || "auto",

          boxShadow:
            headertag.activatedboxShadow || headertag.boxShadow || "none",
          opacity: headertag.activatedOpacity || headertag.opacity || 1,
          display: headertag.activateddisplay || headertag.display || "block",
          flexDirection:
            headertag.activatedflexDirection ||
            headertag.flexDirection ||
            "column",
          flexWrap: headertag.activatedflexWrap || "nowrap",
          order: headertag.activatedorder || "0",
          flexGrow: headertag.activatedflexGrow || "0",
          flexShrink: headertag.activatedflexShrink || "1",
          flexBasis: headertag.activatedflexBasis || "auto",

          gridTemplateColumns: headertag.activatedgridTemplateColumns || "none",
          gridTemplateRows: headertag.activatedgridTemplateRows || "none",
          gridArea: headertag.activatedgridArea || "auto",
          gridAutoFlow: headertag.activatedgridAutoFlow || "row",
          gridAutoColumns: headertag.activatedgridAutoColumns || "auto",
          gridAutoRows: headertag.activatedgridAutoRows || "auto",
          columnGap: headertag.activatedcolumnGap || "0",
          rowGap: headertag.activatedrowGap || "0",

          justifyContent: headertag.activatedjustifyContent || "flex-start",
          alignItems: headertag.activatedalignItems || "stretch",
          alignContent: headertag.activatedalignContent || "stretch",
          alignSelf: headertag.activatedalignSelf || "auto",
          // placeContent: headertag.activatedplaceContent || "normal",
          // placeItems: headertag.activatedplaceItems || "normal",
          justifyItems: headertag.activatedjustifyItems || "stretch",
          justifySelf: headertag.activatedjustifySelf || "auto",

          gap: headertag.activatedgap || "0",
          visibility: headertag.activatedvisibility || "visible",

          color: headertag.activatedcolor || headertag.color || "#000000",
          backgroundColor:
            headertag.activatedbackgroundColor ||
            headertag.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (headertag.activatedbackgroundImage) {
              if (headertag.activatedbackgroundImage.startsWith("./")) {
                const imageName = headertag.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${headertag.activatedbackgroundImage})`;
            }
            if (headertag.backgroundImage) {
              if (headertag.backgroundImage.startsWith("./")) {
                const imageName = headertag.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${headertag.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            headertag.activatedbackgroundPosition ||
            headertag.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            headertag.activatedbackgroundSize ||
            headertag.backgroundSize ||
            "auto",
          backgroundRepeat:
            headertag.activatedbackgroundRepeat ||
            headertag.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            headertag.activatedbackgroundAttachment ||
            headertag.backgroundAttachment ||
            "scroll",

          fontFamily:
            headertag.activatedfontFamily || headertag.fontFamily || "inherit",
          fontSize:
            headertag.activatedfontSize || headertag.fontSize || "inherit",
          fontWeight:
            headertag.activatedfontWeight || headertag.fontWeight || "normal",
          fontStyle:
            headertag.activatedfontStyle || headertag.fontStyle || "normal",
          fontVariant:
            headertag.activatedfontVariant || headertag.fontVariant || "normal",
          lineHeight:
            headertag.activatedlineHeight || headertag.lineHeight || "normal",
          textShadow:
            headertag.activatedtextShadow || headertag.textShadow || "none",
          textAlign:
            headertag.activatedtextAlign || headertag.textAlign || "left",
          verticalAlign:
            headertag.activatedverticalAlign ||
            headertag.verticalAlign ||
            "baseline",
          textDecoration:
            headertag.activatedtextDecoration ||
            headertag.textDecoration ||
            "none",
          textTransform:
            headertag.activatedtextTransform ||
            headertag.textTransform ||
            "none",
          letterSpacing:
            headertag.activatedletterSpacing ||
            headertag.letterSpacing ||
            "normal",
          wordSpacing:
            headertag.activatedwordSpacing || headertag.wordSpacing || "normal",
          textIndent:
            headertag.activatedtextIndent || headertag.textIndent || "0",
          whiteSpace:
            headertag.activatedwhiteSpace || headertag.whiteSpace || "normal",
          textOverflow:
            headertag.activatedtextOverflow || headertag.textOverflow || "clip",
          direction:
            headertag.activateddirection || headertag.direction || "ltr",
          unicodeBidi:
            headertag.activatedunicodeBidi || headertag.unicodeBidi || "normal",
          writingMode:
            headertag.activatedwritingMode ||
            headertag.writingMode ||
            "horizontal-tb",

          cursor: headertag.activatedcursor || headertag.cursor || "default",
          filter: headertag.activatedfilter || headertag.filter || "none",
          backdropFilter:
            headertag.activatedbackdropFilter ||
            headertag.backdropFilter ||
            "none",
          mixBlendMode:
            headertag.activatedmixBlendMode ||
            headertag.mixBlendMode ||
            "normal",
          aspectRatio:
            headertag.activatedaspectRatio || headertag.aspectRatio || "auto",

          transform:
            headertag.activatedtransform || headertag.transform || "none",
          transition:
            headertag.activatedtransition || headertag.transition || "none",
        }
      : {};

  const headertagStyle = {
    width: headertag.width || "100%",
    height: headertag.height || "auto",
    padding: headertag.padding || "8px",
    paddingTop: headertag.paddingTop || headertag.padding || "8px",
    paddingRight: headertag.paddingRight || headertag.padding || "8px",
    paddingBottom: headertag.paddingBottom || headertag.padding || "8px",
    paddingLeft: headertag.paddingLeft || headertag.padding || "8px",
    margin: headertag.margin || "0px",
    marginTop: headertag.marginTop || headertag.margin || "0px",
    marginRight: headertag.marginRight || headertag.margin || "0px",
    marginBottom: headertag.marginBottom || headertag.margin || "0px",
    marginLeft: headertag.marginLeft || headertag.margin || "0px",

    borderTop: headertag.borderTop || headertag.border || "1px solid #000000",
    borderRight: headertag.borderRight || headertag.border || "1px solid #000000",
    borderBottom: headertag.borderBottom || headertag.border || "1px solid #000000",
    borderLeft: headertag.borderLeft || headertag.border || "1px solid #000000",

    borderSapcing: headertag.borderSpacing || "0px",
    borderCollapse: headertag.borderCollapse || "0px",
    borderRadius: headertag.borderRadius || "0",
    boxSizing: headertag.boxSizing || "border-box",

    position: headertag.position || "relative",
    top: headertag.top || "auto",
    right: headertag.right || "auto",
    bottom: headertag.bottom || "auto",
    left: headertag.left || "auto",
    zIndex: headertag.zIndex || "auto",

    display: headertag.display || "block",
    flexDirection: headertag.flexDirection || "column",
    flexWrap: headertag.flexWrap || "nowrap",
    order: headertag.order || "0",
    flexGrow: headertag.flexGrow || "0",
    flexShrink: headertag.flexShrink || "1",
    flexBasis: headertag.flexBasis || "auto",

    gridTemplateColumns: headertag.gridTemplateColumns || "none",
    gridTemplateRows: headertag.gridTemplateRows || "none",
    gridArea: headertag.gridArea || "auto",
    gridAutoFlow: headertag.gridAutoFlow || "row",
    gridAutoColumns: headertag.gridAutoColumns || "auto",
    gridAutoRows: headertag.gridAutoRows || "auto",
    columnGap: headertag.columnGap || "0",
    rowGap: headertag.rowGap || "0",

    justifyContent: headertag.justifyContent || "flex-start",
    alignItems: headertag.alignItems || "stretch",
    alignContent: headertag.alignContent || "stretch",
    alignSelf: headertag.alignSelf || "auto",
    // placeContent: headertag.placeContent || "normal",
    // placeItems: headertag.placeItems || "normal",
    justifyItems: headertag.justifyItems || "stretch",
    justifySelf: headertag.justifySelf || "auto",

    gap: headertag.gap || "0",
    visibility: headertag.visibility || "visible",

    color: headertag.color || "#000000",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),

    backgroundPosition: headertag.backgroundPosition || "0% 0%",
    backgroundSize: headertag.backgroundSize || "auto",
    backgroundRepeat: headertag.backgroundRepeat || "repeat",
    backgroundAttachment: headertag.backgroundAttachment || "scroll",
    boxShadow: headertag.boxShadow || "none",
    filter: headertag.filter || "none",
    backdropFilter: headertag.backdropFilter || "none",
    mixBlendMode: headertag.mixBlendMode || "normal",
    aspectRatio: headertag.aspectRatio || "auto",

    resize: headertag.resize || "none",
    userSelect: headertag.userSelect || "auto",
    overflow: headertag.resize && headertag.resize !== "none" ? "auto" : "visible",
    overflowX: headertag.overflowX || "hidden",
    overflowY: headertag.overflowY || "hidden",

    fontSize: headertag.fontSize || "inherit",
    fontFamily: headertag.fontFamily || "inherit",
    fontWeight: headertag.fontWeight || "normal",
    fontStyle: headertag.fontStyle || "normal",
    fontVariant: headertag.fontVariant || "normal",
    lineHeight: headertag.lineHeight || "normal",
    textAlign: headertag.textAlign || "left",
    textDecoration: headertag.textDecoration || "none",
    textTransform: headertag.textTransform || "none",
    textShadow: headertag.textShadow || "none",
    verticalAlign: headertag.verticalAlign || "baseline",
    letterSpacing: headertag.letterSpacing || "normal",
    wordSpacing: headertag.wordSpacing || "normal",
    textIndent: headertag.textIndent || "0",
    whiteSpace: headertag.whiteSpace || "normal",
    textOverflow: headertag.textOverflow || "clip",
    direction: headertag.direction || "ltr",
    unicodeBidi: headertag.unicodeBidi || "normal",
    writingMode: headertag.writingMode || "horizontal-tb",
    cursor: headertag.cursor || "default",
    outline: headertag.outline || "none",

    backgroundColor: isHovered ? "#ADD8E6" : headertag.backgroundColor || "#ffffff",

    listStyleType: headertag.listStyleType || "disc",
    listStyleImage: headertag.listStyleImage ? `url(${headertag.listStyleImage})` : "none",
    listStylePosition: headertag.listStylePosition || "outside",

    transform: headertag.transform || "none",
    transition:
      headertag.transition || "transform 0.3s ease, background-color 0.3s ease",

    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const [, drop] = useDrop({
    accept: [
      "DroppableDiv",
      "DroppableButton",
      "DroppableImage",
      "DroppableHeading",
      "DroppableParagraph",
      "DroppableIcon",
      "DroppableLink",
      "DroppableCheckbox",
      "DroppableRadio",
      "DroppableList",
      "DroppableTable",
      "DroppableVideo",
      "DroppableAudio",
      "DroppableTextInput",
      "DroppableRangeInput",
      "DroppablePasswordInput",
      "DroppableEmailInput",
      "DroppableNumberInput",
      "DroppableDateInput",
      "DroppableColorInput",
      "DroppableFileInput",
      "DroppableDropDown",
      "DroppableMap",
      "DroppableNav",
      "DroppableHeader",
      "DroppableHGroup",
      "DroppableFooter",
      "DroppableSection",
      "DroppableSpan",
      "DroppableForm",
      "DroppableMain",
      "DroppableArticle",
      "DroppableAside",
      "DroppableHorizontalRule",
      "DroppableLineBreak",
      "DroppableIframe",
    ],
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        if (item.type === "DroppableDiv") {
          addDivision(headertag.id, item.name, item.type);
        } else if (
          item.type === "DroppableNav" ||
          item.type === "DroppableHeader" ||
          item.type === "DroppableHGroup" ||
          item.type === "DroppableFooter" ||
          item.type === "DroppableSection" ||
          item.type === "DroppableSpan" ||
          item.type === "DroppableForm" ||
          item.type === "DroppableMain" ||
          item.type === "DroppableArticle" ||
          item.type === "DroppableAside"
        ) {
          addCanvasDrop(headertag.id, item.name, item.type);
        } else {
          addElement(headertag.id, item.name, item.type);
        }
      }
    },
  });

  const combinedRef = useMemo(
    () => (node) => {
      headertagRef.current = node;
      drop(node);
    },
    [drop]
  );

  return (
    <header
      ref={combinedRef}
      style={headertagStyle}
      onMouseEnter={() => setIsHeadertagHovered(true)}
      onMouseLeave={() => setIsHeadertagHovered(false)}
      onFocus={() => setIsHeadertagFocused(true)}
      onBlur={() => setIsHeadertagFocused(false)}
      onMouseDown={() => setIsHeadertagActive(true)}
      onMouseUp={() => setIsHeadertagActive(false)}
      tabIndex={0}
    >
      {headertag.children &&
        headertag.children.map((child) => {
          switch (child.name) {
            case "Button":
              return <ButtonComponent key={child.id} button={child} />;
            case "Image":
              return <ImageComponent key={child.id} image={child} />;
            case "Heading":
              return <HeaderComponent key={child.id} header={child} />;
            case "Paragraph":
              return <ParagraphComponent key={child.id} paragraph={child} />;
            case "Icon":
              return <IconComponent key={child.id} icon={child} />;
            case "Link":
              return <LinkComponent key={child.id} link={child} />;
            case "Checkbox":
              return <CheckboxComponent key={child.id} checkbox={child} />;
            case "Radio":
              return <RadioComponent key={child.id} radio={child} />;
            case "List":
              return <ListComponent key={child.id} list={child} />;
            case "Table":
              return <TableComponent key={child.id} table={child} />;
            case "Video":
              return <VideoComponent key={child.id} video={child} />;
            case "Text":
              return <TextInputComponent key={child.id} textInput={child} />;
            case "Range":
              return <RangeComponent key={child.id} range={child} />;
            case "Password":
              return (
                <PasswordInputComponent key={child.id} passwordInput={child} />
              );
            case "Email":
              return <EmailInputComponent key={child.id} emailInput={child} />;
            case "Number":
              return (
                <NumberInputComponent key={child.id} numberInput={child} />
              );
            case "Date":
              return <DateInputComponent key={child.id} dateInput={child} />;
            case "Color":
              return <ColorInputComponent key={child.id} colorInput={child} />;
            case "File":
              return <FileInputComponent key={child.id} fileInput={child} />;
            case "Audio":
              return <AudioComponent key={child.id} audio={child} />;
            case "DropDown":
              return <DropDownComponent key={child.id} dropdown={child} />;
            case "Output":
              return <OutputComponent key={child.id} output={child} />;
            case "Map":
              return <MapComponent key={child.id} map={child} />;
            case "Span":
              return <Span key={child.id} span={child} />;
            case "Form":
              return <FormComponent key={child.id} form={child} />;
            case "Main":
              return <MainComponent key={child.id} main={child} />;
            case "Article":
              return <ArticleComponent key={child.id} article={child} />;
            case "Aside":
              return <AsideComponent key={child.id} aside={child} />;
            case "HorizontalRule":
              return <HRTag key={child.id} div={child} />;
            case "LineBreak":
              return <BRTag key={child.id} div={child} />;
            case "Iframe":
              return <IframeComponent key={child.id} div={child} />;
            case "Nav":
              return <Nav key={child.id} nav={child} />;
            default:
              return <Division key={child.id} div={child} />;
          }
        })}
    </header>
  );
};

export default HeaderTag;
